// Swiper is imported already
(async () => {
  if (!customElements.get('product-detail-swiper')) {
    class ProductDetailSwiper extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-product-detail-swiper]');

        this.swiperOptions = {
          direction: 'horizontal',
        };

        this.init();
      }

      init() {
        window.addEventListener('load', (event) => {
          this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
        });
      }
    }

    customElements.define('product-detail-swiper', ProductDetailSwiper);
  }

  if (!customElements.get('product-sticky-atc')) {
    class ProductStickyAtc extends HTMLElement {
      constructor() {
        super();

        this.sizeVariants = this.querySelectorAll('[data-sticky-atc-variant]');
        this.sizeVariants.forEach((sizeVariant) => {
          sizeVariant.addEventListener('click', (event) => {
            if (event.target.dataset && event.target.dataset.stickyAtcVariantId) {
              let variantData = event.target.dataset.stickyAtcVariantId;
              this.handleAddToCart(variantData, true);
            }
          });
        });

        this.outOfStockOptions = this.querySelectorAll('[data-variant-disabled]');
        this.outOfStockOptions.forEach((outOfStock) => {
          outOfStock.addEventListener('click', (event) => {
            if (
              event.target.closest('[data-sticky-atc-variant]').dataset &&
              event.target.closest('[data-sticky-atc-variant]').dataset.stickyAtcVariantId
            ) {
              let variantData = event.target.closest('[data-sticky-atc-variant]').dataset
                .stickyAtcVariantId;
              this.handleAddToCart(variantData, false);
            }
          });
        });

        this.trackAtc();
      }

      trackAtc() {
        let atc = document.querySelector('[data-track-add-to-cart]');
        let offsetTop = atc.offsetTop;
        let offsetBottom = offsetTop + window.innerHeight + atc.clientHeight;

        if (window.innerWidth < 768) {
          if (window.innerHeight < offsetTop) {
            document.querySelector('product-sticky-atc').classList.add('hidden');
          } else {
            document.querySelector('product-sticky-atc').classList.remove('hidden');
          }
        }

        window.addEventListener(
          'scroll',
          () => {
            let currentScroll = window.innerHeight + window.scrollY;
            if (currentScroll > offsetTop) {
              if (currentScroll > offsetBottom) {
                document.querySelector('product-sticky-atc').classList.remove('hidden');
                if (window.innerWidth < 768) {
                  document.body.style.paddingBottom = '87.33px';
                } else {
                  document.body.style.paddingBottom = '0';
                }
              } else {
                document.querySelector('product-sticky-atc').classList.add('hidden');
              }
            } else {
              document.querySelector('product-sticky-atc').classList.add('hidden');
            }
          },
          false
        );
      }

      handleAddToCart(variantData, addToCart) {
        document.querySelector('input[value="' + variantData + '"]').click();
        setTimeout(function () {
          document.body.classList.remove('variant-selector-open');
          if (addToCart) {
            document.querySelector('[data-track-add-to-cart]').click();
          } else {
            document.querySelector('.klaviyo-bis-trigger').click();
          }
        }, 500);
      }
    }

    customElements.define('product-sticky-atc', ProductStickyAtc);
  }

  if (!customElements.get('product-info')) {
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.productForm = this.querySelector('product-form');
        this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
        this.quantityInput = this.querySelector('quantity-input');
        this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
        this.quantityInputElement?.addEventListener('change', () => {
          this.handleQuantityInput();
        });

        let descriptionTrigger = this.querySelector('[data-product-description-trigger]');
        let productDescription = this.querySelector('[data-product-tabs-description]');
        if (descriptionTrigger && productDescription) {
          descriptionTrigger.addEventListener('click', (event) => {
            productDescription.classList.add('collapsible-is-open');
            productDescription.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        }
      }

      /**
       * handleQuantityInput
       * @description Set the quantity from the quantity input web component to the product form web component.
       */
      handleQuantityInput() {
        this.productFormQuantity.value = this.quantityInputElement.value;
      }
    }
    customElements.define('product-info', ProductInfo);
  }
})();
